import React from "react";
import { useParams } from "react-router-dom";
import { ErrorBox, Loading, Pane, Text } from "shared";
import { useTranslation } from "react-i18next";
import { useHealthCareOrganization } from "../queries/useHealthCareOrganizations";
import HcoInfo from "./HcoInfo";

export const Account: React.VFC = () => {
  const { t } = useTranslation();
  const { item } = useParams<{ item: string }>();
  const id = Number(item) || 0;
  const { data: hco, error, isLoading, isSuccess } = useHealthCareOrganization(id);

  const mainEm = hco && (
    <Pane>
      <HcoInfo hco={hco} />
    </Pane>
  );

  const altEm = (
    <Pane>
      {error && <ErrorBox error={error} verbose dark />}
      {isLoading && <Loading />}
    </Pane>
  );

  return (
    <div>
      <Text paragraph caption secondary>
        {t("views.health_care_organizations")}
      </Text>
      {isSuccess ? mainEm : altEm}
    </div>
  );
};
